import {
  IPreferencesUser,
  IViewContextUserPreferences
} from "@/features/financas/views/Indicadores/@types/type";

export interface IUserPreferencesGateway {
  getUserPreferences(
    params: IViewContextUserPreferences
  ): Promise<IPreferencesUser[] | undefined>;
  salvarUserPreferences(params: IPreferencesUser): Promise<boolean | undefined>;
  deleteUserPreferences(id: string): Promise<boolean | undefined>;
}

export const UserPreferencesGatewayDi = Symbol("UserPreferencesGatewayDi");
